


/**
 * a Sprite is owned by an Entity, responsible for handling the entity's visual display
 */
export default class Sprite {

	constructor(args) {
		this._args = args;
		this.entity = null;
		this.scene = null;
		this.layer = null;
		this.container = null;
		this.system = null;
		this.body = null;
		this.g = null;
	}

	init(entity) {
		this.entity = entity;
		this.scene = entity.scene;
		this.system = entity.system;
	}

	update(delta, deltaNormal) {
		// I am a Sprite and I am updating my display objects ready for rendering
	}

	hide() {
		//
	}

	destroy() {
		//
	}

}